<template>
	<GlassCard class="p-2">
		<h2 class="p-2">Monthly Detail Report</h2>
		<input
			type="month"
			v-model="selectedMonth"
			@change="fetchNutritionData"
			v-if="isOnline" />
		<canvas ref="canvas"></canvas>
	</GlassCard>
</template>

<script setup>
	import { ref, watch, onMounted, onBeforeMount, onBeforeUnmount } from "vue"
	import GlassCard from "./GlassCard.vue"
	import Chart from "chart.js/auto"
	import moment from "moment-timezone"
	// import { useTokenStore } from "@/stores/token"
	// import { useRouter } from "vue-router"
	// import { hasTokenIssue, handleTokenIssue } from "@/utils/tokenIssue"
	import { fetchWithAuth } from "@/utils/api-client"
	// import { lastMealUpdated, lastMealDeleted } from "@/utils/mealBus"
	import EventBus from "@/utils/eventBus"
	import { isOnline } from "@/utils/networkBus"

	const selectedMonth = ref(moment().format("YYYY-MM"))
	const nutritionData = ref([])
	const canvas = ref(null)

	// const router = useRouter()
	// const tokenStore = useTokenStore()

	let myChart = null

	async function fetchNutritionData(month) {
		if (typeof month === "string") {
			// console.log(month)
			const [year, monthPart] = month.split("-")
			const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
			const response = await fetchWithAuth(
				`/api/report/monthly-detailed?year=${year}&month=${monthPart}`,
				{
					method: "GET",
					headers: {
						"User-Timezone": tz,
						// Authorization: `Bearer ${tokenStore.token}`,
					},
				}
			)

			// if (hasTokenIssue(response)) {
			// 	handleTokenIssue(response)
			// } else {
			nutritionData.value = await response.json()

			if (myChart) {
				myChart.destroy()
			}

			// const ctx = canvas.value.getContext("2d")
			myChart = new Chart(canvas.value, {
				type: "bar",
				data: {
					labels: nutritionData.value.map((data) => data.day),
					datasets: [
						// {
						// 	label: "Calories",
						// 	data: nutritionData.value.map((data) => data.totalCalories),
						// 	backgroundColor: "red",
						// },
						{
							label: "Protein",
							data: nutritionData.value.map((data) => data.totalProtein),
							backgroundColor: "#4e79a7",
						},
						{
							label: "Carbs",
							data: nutritionData.value.map((data) => data.totalCarbs),
							backgroundColor: "#f28e2b",
						},
						{
							label: "Fats",
							data: nutritionData.value.map((data) => data.totalFats),
							backgroundColor: "#59a14f",
						},
						{
							label: "Fiber",
							data: nutritionData.value.map((data) => data.totalFiber),
							backgroundColor: "#9c755f",
						},
						{
							label: "Sugars",
							data: nutritionData.value.map((data) => data.totalSugars),
							backgroundColor: "#edc948",
						},
						{
							label: "Sodium",
							data: nutritionData.value.map((data) => data.totalSodium),
							backgroundColor: "#76b7b2",
							hidden: true,
						},
						{
							label: "Cholesterol",
							data: nutritionData.value.map((data) => data.totalCholesterol),
							backgroundColor: "#b07aa1",
							hidden: false,
						},
					],
				},
				options: {
					scales: {
						y: {
							beginAtZero: false,
							ticks: {
								color: "white",
							},
						},
						x: {
							ticks: {
								color: "white",
							},
						},
					},
					plugins: {
						legend: {
							labels: {
								color: "white",
							},
						},
					},
					responsive: true,
				},
			})
			// }
		}
	}

	onMounted(() => {
		// console.log(canvas.value)
		fetchNutritionData(selectedMonth.value)
	})

	watch(
		selectedMonth,
		(newMonth) => {
			fetchNutritionData(newMonth)
		}
		// { immediate: true }
	)

	// watch(lastMealUpdated, (v) => {
	// 	fetchNutritionData(selectedMonth.value)
	// })

	// watch(lastMealDeleted, (v) => {
	// 	fetchNutritionData(selectedMonth.value)
	// })

	let offMealUpdated = null
	let offMealDeleted = null

	onBeforeMount(() => {
		offMealUpdated = EventBus.on("meal-updated", () => {
			fetchNutritionData(selectedMonth.value)
		})

		offMealDeleted = EventBus.on("meal-deleted", () => {
			fetchNutritionData(selectedMonth.value)
		})
	})

	onBeforeUnmount(() => {
		if (offMealUpdated) offMealUpdated()
		if (offMealDeleted) offMealDeleted()
	})
</script>
